export default __webpack_public_path__ + "static/media/google-play.f902960a.png";